module.exports = __webpack_public_path__ + "img/room_bg2.6660d508.png";